import React from "react";
import { Link } from "react-router-dom";
import { useAtom } from "jotai";
import { loggedInUser, accountType, teamIDCheck } from "../../../utils/store";
import { trackEvent } from "../../../utils/mixpanel";
import cardIcon from "../../../assets/images/function_page_icons/cardIcon.svg";
import paymentIcon from "../../../assets/images/function_page_icons/paymentIcon.svg";
import emergencyIcon from "../../../assets/images/function_page_icons/emergencyIcon.svg";
import customIcon from "../../../assets/images/function_page_icons/customIcon.svg";
import fileUploadIcon from "../../../assets/images/function_page_icons/fileUploadIcon.svg";
import formbuilderIcon from "../../../assets/images/function_page_icons/formbuilderIcon.svg";
import memoryIcon from "../../../assets/images/function_page_icons/memoryIcon.svg";
import medicalIcon from "../../../assets/images/function_page_icons/medicalIcon.svg";
import { MdOutlineArrowForwardIos } from "react-icons/md";

const FunctionCard = ({
  bgColor,
  image,
  FunctionCreateCardsObj,
  title,
  function_type,
  description,
  url,
  teamId,
  userId,
  dataIntro,
  dataStep,
  personalCardsCount,
  businessCardsCount,
  formBuilderCount,
  memoryCount,
  payment,
  emergencyContacts,
  customUrls,
  medicalCount,
  files,
  isVisible,
}) => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [personalAccount, setPersonalAccount] = useAtom(accountType);
  const [userTeamId] = useAtom(teamIDCheck);
  const connectedTeam = Array.isArray(loggedUser?.connected_teams)
    ? loggedUser.connected_teams.find(
        (team) => String(team.id ?? team.team_id) === String(userTeamId)
      ) || loggedUser.connected_teams[0]
    : loggedUser?.connected_teams;
  const currentMembership =
    loggedUser?.team_members?.find(
      (member) =>
        String(member.team_id) === String(userTeamId) &&
        loggedUser?.email &&
        member.user_data?.email === loggedUser.email
    ) ||
    loggedUser?.team_members?.find(
      (member) =>
        String(member.team_id) === String(userTeamId) &&
        String(member.user_id) === String(loggedUser?.id)
    );
  const currentUserId =
    currentMembership?.user_id ||
    connectedTeam?.pivot?.user_id ||
    connectedTeam?.team_member?.user_id ||
    connectedTeam?.membership?.user_id ||
    loggedUser?.user_data?.id ||
    loggedUser?.id ||
    "";
  const handleTracking = (data) => {
    trackEvent(data, {
      message: data,
    });
  };
  return (
    <>
      <div className="isVisible" data-intro={dataIntro} data-step={dataStep}>
        <Link
          to={
            teamId && userId
              ? `/team/${teamId}/teamMembers/member/${userId}${url}`
              : `${url}${
                  !personalAccount
                    ? `?team_id=${
                        userTeamId || (loggedUser?.teams?.id ? loggedUser.teams.id : "")
                      }&user_id=${
                        currentUserId
                      }`
                    : ""
                }`
          }
          onClick={() => handleTracking("Create Function Button Clicked")}
        >
          <div className="cardWrapper d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="imgWrapper">
                {/* {function_type === "card" ? (
              <CardFunctionLogo
                primaryColor="var(--button_text_color)"
                secondaryColor="var(--primary_button_color)"
              />
            ) : function_type === "payment" ? (
              <Paymenticon
                primaryColor="var(--button_text_color)"
                secondaryColor="var(--primary_button_color)"
              />
            ) : function_type === "emergency_contact" ? (
              <Emergencycontactlogo
                primaryColor="var(--button_text_color)"
                secondaryColor="var(--border_color)"
              />
            ) : function_type === "custom_url" ? (
              <CustomURLsLogo
                primaryColor="var(--heading_text_color)"
                secondaryColor="var(--primary_button_color)"
                accentColor="var(--border_color)"
              />
            ) : function_type === "file_upload" ? (
              <UploadFilesIcon
                primaryColor="var(--heading_text_color)"
                secondaryColor="var(--primary_button_color)"
              />
            ) : function_type === "form_builder" ? (
              <FormBuilderLogo
                primaryColor="var(--heading_text_color)"
                secondaryColor="var(--primary_button_color)"
              />
            ) : function_type === "memory" ? (
              <MyMemoryLogo
                primaryColor="var(--button_text_color)"
                secondaryColor="var(--primary_button_color)"
              />
            ) : function_type === "medical_id" ? (
              <MedicalIDLogo
                primaryColor="var(--button_text_color)"
                secondaryColor="var(--border_color)"
              />
            ) : (
              ""
            )} */}
                {function_type === "card" ? (
                  <img src={cardIcon} alt="" className="img-fluid" />
                ) : function_type === "payment" ? (
                  <img src={paymentIcon} alt="" className="img-fluid" />
                ) : function_type === "emergency_contact" ? (
                  <img src={emergencyIcon} alt="" className="img-fluid" />
                ) : function_type === "custom_url" ? (
                  <img src={customIcon} alt="" className="img-fluid" />
                ) : function_type === "file_upload" ? (
                  <img src={fileUploadIcon} alt="" className="img-fluid" />
                ) : function_type === "form_builder" ? (
                  <img src={formbuilderIcon} alt="" className="img-fluid" />
                ) : function_type === "memory" ? (
                  <img src={memoryIcon} alt="" className="img-fluid" />
                ) : function_type === "medical_id" ? (
                  <img src={medicalIcon} alt="" className="img-fluid" />
                ) : (
                  ""
                )}
              </div>
              <div className="infoWrapper">
                <h3>{title}</h3>
                <p className="mb-0">{description}</p>
              </div>
            </div>

            {/* <div className="btnWrapper">
            <Link
              to={
                teamId && userId
                  ? `/team/${teamId}/teamMembers/member/${userId}${url}`
                  : `${url}${
                      loggedUser?.role?.includes("team_owner") &&
                      !personalAccount
                        ? `?team_id=${
                            Object.keys(loggedUser).length !== 0
                              ? loggedUser.teams.id
                              : null
                          }&user_id=${
                            Object.keys(loggedUser).length !== 0
                              ? loggedUser.teams.user_id
                              : null
                          }`
                        : ""
                    }`
              }
              onClick={() => handleTracking("Create Function Button Clicked")}
            >
              {(function_type === "card" &&
                (personalCardsCount > 0 || businessCardsCount > 0)) ||
              (function_type === "payment" && payment.length > 0) ||
              (function_type === "emergency_contact" &&
                emergencyContacts.length > 0) ||
              (function_type === "custom_url" && customUrls.length > 0) ||
              (function_type === "file_upload" && files.length > 0) ||
              (function_type === "form_builder" && formBuilderCount > 0) ||
              (function_type === "memory" && memoryCount > 0) ||
              (function_type === "medical_id" && medicalCount > 0) ? (
                <button className="createBtn">Manage Function</button>
              ) : (
                <button className="createBtn">Create</button>
              )}
            </Link>
          </div> */}

            <MdOutlineArrowForwardIos />
          </div>
        </Link>
      </div>
    </>
  );
};
export default FunctionCard;
